module.exports = __webpack_public_path__ + "img/数字化订货banner1.6c85bda7.png";